export default __webpack_public_path__ + "static/media/calender.fbab370f.svg";